export default "__VITE_ASSET__771240cd__"